module.exports = __webpack_public_path__ + "img/surat-list-penduduk-min.06add057.png";